export default __webpack_public_path__ + "static/media/solarimg2.eb59d17c.png";